var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1502 1502",
    viewBox: "0 0 1502 1502",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1102.6 839.8c97.6 2 187.3-23.5 267.3-79.6 31-21.7 62.2-31.4 96.4-10.8 35.2 21.2 37.4 55.4 33 91.6-48.8 402.7-415 696.4-816.9 655.2-347.1-35.6-616.7-289.8-672.2-633.9-64.8-401.9 217.9-789.4 622.3-853 15.8-2.5 31.6-5 47.5-6.7 32.1-3.5 58.3 7.4 74.6 35.8 17 29.6 13 58.7-6.4 86.3-46.8 66.7-76 139.7-82.7 221.8-21.6 264.5 171.9 483.4 437.1 493.3zm212.3 117.3c-238.8 69.4-450.8 28.9-624.6-144.9-174.6-174.6-214-388.1-144.6-624.7-202.3 65.7-423.8 294.5-390.9 629.3 27.1 275.3 264.1 508.7 535.9 532.1 345.5 29.7 566.8-205.2 624.2-391.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.c741cd374c95bc4c5a0d436d9a47c322.svg";
export { ForwardRef as ReactComponent };